import { createStyles, Theme } from '@nelnet/unifi-components-react';

const subnavstyles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      position: 'absolute',
      top: '8rem',
      right: spacing(4),
    },
    itemSubnav: {
      position: 'relative',
      backgroundColor: 'transparent',
      fontSize: '1rem',
      '&:before': {
        content: '""',
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: 0,
        borderLeft: '4px solid #e5e5e5',
      },
      '& a': {
        paddingTop: '0 !important',
        paddingBottom: '0 !important',
        paddingLeft: spacing(3),
        color: 'inherit',
        fontSize: 'inherit',
      },
      '& a:hover': {
        backgroundColor: 'transparent',
      },
      '& a span': {
        color: 'inherit',
        fontSize: 'inherit',
        lineHeight: 1.5,
        display: 'block',
      },
      '& li.active a:before': {
        content: '""',
        position: 'absolute',
        top: '.25em',
        bottom: '.25em',
        left: 0,
        borderLeft: '3px solid currentColor',
      },
    },
    angular: {
      color: '#c3002f',
    },
    react: {
      color: '#007C9D',
    },
    web: {
      color: '#D13D1B',
    },
  });

export default subnavstyles;
